// Suppress browser extension errors (e.g. MetaMask) BEFORE React mounts
window.addEventListener('unhandledrejection', (event) => {
  const reason = String(event.reason ?? '');
  if (reason.includes('MetaMask') || reason.includes('chrome-extension')) {
    event.preventDefault();
    return;
  }
});

import { createRoot } from 'react-dom/client'
import AppWrapper from './App.wrapper.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <AppWrapper />
);
